import React from 'react';
import { useEffect } from 'react';
import { selectLINKtivityAccessAllowed } from '../../../common/subscription/SubscriptionSlice';
import { Breadcrumbs, Button, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import PageTitle from '../../../common/components/PageTitle';
import Categories from '../Categories';
import PreviewMode from '../PreviewMode';
import NewAndFeaturedList from '../NewAndFeaturedList';
import { useNavigate } from 'react-router-dom';
import { LTVLIBNEWANDFEATURED } from '../../../routes/CONSTANTS';

export function LtvLibHome() {
  const LINKtivityAccessAllowed = useSelector(selectLINKtivityAccessAllowed);
  const navigate = useNavigate();

  const handleViewAllNewFeaturedClick = (event) => {
    event.preventDefault();
    navigate(LTVLIBNEWANDFEATURED);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Breadcrumbs aria-label='breadcrumb' sx={{ paddingBottom: 2 }}>
        <Typography key='1' color='primary.main'>
          Library Home
        </Typography>
      </Breadcrumbs>
      <PageTitle
        title={
          LINKtivityAccessAllowed
            ? 'LINKtivity® Library'
            : 'LINKtivity® Library - PREVIEW'
        }
      />
      <Typography variant='h4'>New and Featured LINKtivities</Typography>
      <NewAndFeaturedList numItems={3} />
      <Button
        variant='contained'
        onClick={handleViewAllNewFeaturedClick}
        style={{ margin: '30px' }}
        size='large'
      >
        See All New & Featured
      </Button>
      <Typography
        variant='h4'
        style={{ marginTop: '40px', marginBottom: '20px' }}
      >
        All LINKtivities by Category
      </Typography>
      <Categories />
      {!LINKtivityAccessAllowed && <PreviewMode />}
    </>
  );
}
